export function convertWidgetToReactPath(w?: string, p?: string): string {
  const path: string = p || '';

  if (!w) return path;

  return w.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
}
